import {
    apiRequest,
    identitasDetail,
    identitasApprove
} from "../../../../../services/adapters/kepegawaian/indentitasService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", identitasDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", identitasApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository